/* @flow */

import type { MESSAGE_MODAL_TYPE } from '../../components/modal/messageModal/MessageModal';
import type { KeyValuePair } from '../jsHelpers/types';

import { HttpStatus } from '../../libs/netgemLibrary/v8/constants/NetworkCodesAndMessages';
import { ParentalGuidanceRatingSystem } from '../../libs/netgemLibrary/v8/types/ParentalGuidance';
import Localizer from '../localization';
import { ParentalControlLabels } from './constsAndTypes';

const fetchHttpStatus: (url: URL | string, options: KeyValuePair<string>) => Promise<number> = async (url, options) => {
  const { status } = await fetch(url, options);
  return status;
};

const fetchJson: (url: URL | string, options: KeyValuePair<string>) => Promise<{ contact?: boolean, retryAfter?: string | null, status?: string, tooManyRequests?: boolean }> = async (
  url,
  options,
) => {
  const response = await fetch(url, options);
  const { status } = response;

  // Duration in seconds
  const retryAfter = response.headers.get('Retry-After');

  if (status === HttpStatus.TooManyRequests) {
    return { retryAfter, tooManyRequests: true };
  }

  const data = await response.json();

  return { ...data, retryAfter };
};

const countryCodeToRatingSystem = (countryCode: string): ParentalGuidanceRatingSystem => {
  switch (countryCode.toLowerCase()) {
    case 'usa':
      return ParentalGuidanceRatingSystem.USA_PR;

    case 'gbr':
    case 'gb':
      return ParentalGuidanceRatingSystem.BBFC;

    case 'irl':
      return ParentalGuidanceRatingSystem.IFCO;

    default:
      return ParentalGuidanceRatingSystem.Default;
  }
};

const stringToRatingSystem = (ratingSystem: ?string): ParentalGuidanceRatingSystem => {
  switch (ratingSystem?.toLowerCase()) {
    case 'bbfc':
      return ParentalGuidanceRatingSystem.BBFC;

    case 'ifco':
      return ParentalGuidanceRatingSystem.IFCO;

    case 'pegi':
      return ParentalGuidanceRatingSystem.PEGI;

    case 'usa_pr':
      return ParentalGuidanceRatingSystem.USA_PR;

    case 'default':
    default:
      return ParentalGuidanceRatingSystem.Default;
  }
};

const formatMinAge = (ratingSystem: ParentalGuidanceRatingSystem, minAge: number): string => {
  switch (ratingSystem) {
    case ParentalGuidanceRatingSystem.BBFC:
    case ParentalGuidanceRatingSystem.IFCO:
    case ParentalGuidanceRatingSystem.PEGI:
    case ParentalGuidanceRatingSystem.USA_PR:
      return ParentalControlLabels[ratingSystem as string].find(({ minAge: age }) => age === minAge)?.label ?? '';

    case ParentalGuidanceRatingSystem.Default:
      return minAge > 0 ? `-${minAge}` : Localizer.localize('common.metadata.no_age_restriction');

    // No default
  }
};

const showUnavailableContentModal = (showMessageModal: (messageData: MESSAGE_MODAL_TYPE) => void) => {
  showMessageModal({
    buttonText: Localizer.localize('common.actions.ok'),
    message: Localizer.localize('modal.message.unavailable_content_for_device_text'),
    title: Localizer.localize('modal.message.unavailable_content_for_device_title'),
  });
};

export { countryCodeToRatingSystem, fetchHttpStatus, fetchJson, formatMinAge, showUnavailableContentModal, stringToRatingSystem };
